import { useIsMobile } from "../volleyball/context/mobileContext";
import FootballDesktopDashboard from "./screens/FootballDesktopDashboard";
import FootballMobileDashboard from "./screens/FootballMobileDashboard";

const FootballDashboard = () => {
  const isMobile = useIsMobile();
  return isMobile ? <FootballMobileDashboard /> : <FootballDesktopDashboard />;
};

export default FootballDashboard;
